import Footer from "../../../components/Footer/Footer";
import NavBar from "../../../components/NavBar/NavBar";

import Title from "../../../components/Title/Title";
import CustomButton from "../../../components/Custom-Button/CustomButton";

export default function EigthCommandment() {

    return (
        <div>
            <NavBar/>
            <Title text={"Não Levantar Falso Testemunho Contra o Próximo "}/>

            <p className="info-text">
            É mandamento da veracidade. Ordena a dizer a verdade e viver nela (veritas)[83][84]. <br/>
            Surgiu porque Israel era chamado a testemunhar Deus, a Verdade. <br/>
            Faltar com a verdade nos relacionamentos é pecar contra Deus e ferir a confiança humana[83]. <br/>
            O Catecismo afirma: Deus é a fonte da verdade, e Cristo Se declarou “a Verdade” (Jo 14,6)[85]. <br/>
            O ser humano, pela sua dignidade, tem obrigação moral de procurar e falar a verdade sobre Deus e sobre seus irmãos[84]. <br/>
            Mentir ou enganar é injustiça contra o próximo: “por justiça, cada homem deve honestamente ao outro a manifestação da verdade”[86].
            </p> 

            <Title text={"Aplicação Cotidiana"}/>
            <p className="info-text">
            Na vida de cada dia, é ser honesto nas palavras e ações. 
            Significa não mentir, nem enganar em negociações, provas escolares, impostos, etc. 
            Cumprir promessas, devolver troco errado, citar fontes corretamente em trabalhos acadêmicos, não espalhar boatos – tudo é aplicação concreta. 
            O mandamento abrange também o respeito à boa reputação alheia: condena a calúnia (falar falso para difamar), a difamação (dizer fatos verdadeiros de maneira maliciosa), o juízo temerário (acreditar e espalhar culpa sem provas) e a fofoca sem propósito construtivo[87][88]. 
            Ajudar a corrigir erros dos outros com amor (e não expor suas faltas sem necessidade) é incentivado[88][89]. 
            Mesmo conversas casuais pedem prudência: dizer coisas irreverentes para ser “engraçado” pode ofender. 
            Em família e amigos, fala-se com sinceridade amorosa: conselho honesto, evitando mentiras “brancas” que possam causar mal. 
            Em sociedade, respeitar a lei que exige o testemunho verdadeiro em tribunal é um exemplo direto do mandamento[87].
            </p> 

            <Title text={"Aspectos Teológicos"}/>

            <p className="info-text">
            A verdade é atributo divino (Deus “não pode mentir” – Tt 1,2). Assim, pisotear a verdade alheia ofende a Deus[90]. 
            Este mandamento insere-se no mandamento do amor: confiar no outro (valorizando sua palavra) e ser digno de confiança. 
            A tradição da Igreja coloca a veracidade como virtude fundamental para a justiça e para a caridade[84]. 
            O CIC explica que aquele que fala em nome de Cristo (cristão) não deve mentir nem ocultar-se atrás de segredos escandalosos[91][92]. 
            A mentira, aponta o texto, é “obra do diabo” (Jo 8,44) e destrói a confiança social[92][93]. 
            Por isso, todo cristão é chamado a ser “luz do mundo” pela sinceridade. 
            A reparação (pôr-se em paz) quando se ofendeu a verdade ou a honra alheia também é dever moral (mesmo que perdoados)[94]. 
            Em última instância, amar a Deus e ao próximo nos leva a honrar a palavra dada, fazendo da nossa vida “uma vez sim, uma vez não, nada mais além” (Mt 5,37)[19].
            </p> 

  
            <CustomButton route={"/Mandamentos"} text={"Voltar"}/>
            <Footer/>
        </div>
    )
}